import { Component, Inject, OnInit } from '@angular/core';
import { MessagePopup } from '@core/models';

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss'],
  imports: [MatButtonModule, MatDialogModule],
})
export class MessageModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessagePopup,
    private dialogRef: MatDialogRef<MessageModalComponent>,
  ) {}

  ngOnInit(): void {}

  closeModal(accept: boolean = null): void {
    this.dialogRef.close(accept);
  }
}
